import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { CircularProgress, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Button from '../../../common/components/Button/Button';

export function LoginFormWrapper({ config, title, isFetching = false, children, backToLoginBtn, text, error }) {
  const logoPath = get(config, 'logoMain', '');
  const navigate = useNavigate();

  const backToLogin = () => {
    navigate('/login');
  };

  return (
    <div className={`login-wrapper${error ? ' has-error' : ''}`}>
      <Paper className="login-paper">
        <div className="loading-block-wrapper">
          <div className="login-logo">
            <img alt="logo-img" src={logoPath} />
          </div>
          {title && <h3>{title}</h3>}
          {isFetching && (
            <div className="loading-block">
              <CircularProgress />
            </div>
          )}
          {children}
          {text && <p style={{ padding: '10px 0' }}>{text}</p>}
          {backToLoginBtn && (
            <div className="login-form-btns">
              <div className="login-btns">
                <Button type="button" color="secondary" onClick={backToLogin}>
                  Login
                </Button>
              </div>
            </div>
          )}
          <div className="login-error">{error || ''}</div>
        </div>
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => ({
  config: state.appConfig?.config,
});

export default connect(mapStateToProps)(LoginFormWrapper);
